import * as Ably from 'ably'

export default defineNuxtPlugin(() => {
  const { socketURL, isDev, apiURL } = useRuntimeConfig().public
  const { auth } = $store()
  const channels: { [key: string]: any } = {}
  let event: Ably.Realtime | null = null

  const connect = (isClient: boolean = true) => {
    if (event) {
      event.close()
      return
    }
    const workspaceId = auth.workspaceId
    const accessToken = auth.accessToken
    const options: any = isClient
      ? {
          authUrl: apiURL + '/system/auth-ably',
          authHeaders: {
            Authorization: 'Bearer ' + accessToken || '',
            'hts-workspace': workspaceId || ''
          }
        }
      : {
          authUrl: apiURL + '/admincp/system/auth-ably',
          authHeaders: {
            Authorization: 'Bearer ' + accessToken || ''
          }
        }
    event = new Ably.Realtime(options)
    event.connection.on('connected', () => {
      // eslint-disable-next-line no-console
      console.log('Event connected')
    })
    event.connection.on('failed', () => {
      // eslint-disable-next-line no-console
      console.log('Event connect failed')
    })
  }

  const listen = (channel: string, callback: any) => {
    if (!event) {
      return
    }
    const channelList = event.channels.get(channel)
    channelList.subscribe(channel, (message) => {
      if (typeof callback === 'function') {
        callback(message.data)
      }
    })
  }

  const unsubscribe = (channel: string, callback: any) => {
    if (!event) {
      return
    }
    const channelList = event.channels.get(channel)
    channelList.unsubscribe()
  }

  const disconnect = () => {
    event?.close()
    event?.connection.on('disconnected', () => {
      // eslint-disable-next-line no-console
      console.log('Event disconnected')
    })
  }

  return {
    provide: {
      event: {
        connect,
        listen,
        disconnect,
        unsubscribe
      }
    }
  }
})
